import network from '@common/network/network';

import {normalizeAgentSkillClient} from './normalizers';

export default {
  fetchAgentSkillClientAction(context, {id}) {
    return network.research.getResearchClient({id}).then(response => normalizeAgentSkillClient(response));
  },
  searchAgentSkillClientsAction(context, {query}) {
    return network.research.searchResearchClients({query}).then(response => {
      const results = Array.isArray(response?.objects) ? response.objects : Array.isArray(response) ? response : [];
      return results.map(normalizeAgentSkillClient).filter(Boolean);
    });
  },
};
